import React from 'react';
import { motion } from 'framer-motion';
export function PainPoints() {
  return <section className="py-24 px-4 bg-black" data-id="element-175">
      <div className="max-w-3xl mx-auto" data-id="element-176">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-177">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-178">
            ¿Te suena conocido esto?
          </h2>
          <p className="text-lg text-gray-300 leading-relaxed bg-dark-card p-6 rounded-2xl border border-dark-border" data-id="element-179">
            Domingo a las 10 de la noche. Mañana tienes práctica de taller y
            clase teórica de bromatología. Y todavía estás buscando cómo
            explicar el sistema HACCP sin que parezca una lista interminable de
            siglas, o cómo armar una actividad de análisis sensorial con lo que
            tenés disponible en la escuela.
            <br data-id="element-180" />
            <br data-id="element-181" />
            <span className="text-gold-light font-medium" data-id="element-182">
              No es tu culpa.
            </span>{' '}
            Es que llevas años trabajando con materiales pensados para
            ingenieros de industria, manuales universitarios que tus alumnos no
            pueden leer solos, o recursos de otros países con regulaciones que
            no aplican al tuyo.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-183">
          <h3 className="text-xl font-bold text-white mb-8 text-center" data-id="element-184">
            El costo de no tener el material correcto:
          </h3>

          <ul className="space-y-4" data-id="element-185">
            {['Noches enteras buscando cómo traducir la normativa del Codex Alimentarius o de ARCSA, SENASAG, INVIMA, ANMAT a un lenguaje que tus alumnos técnicos puedan entender y aplicar', 'Clases improvisadas porque no encontraste a tiempo una actividad de microbiología alimentaria o un caso real de ETA para analizar en el aula', 'Alumnos desconectados que sienten que la bromatología es teoría pura y no ven la conexión con el taller, con los alimentos reales y con su futura vida profesional', 'Silencios incómodos cuando un alumno pregunta la diferencia real entre una BPM y un procedimiento HACCP, o qué pasa exactamente con las micotoxinas en el maíz que compran en el mercado', 'Fines de semana perdidos armando fichas técnicas, evaluaciones y actividades de laboratorio desde cero, una y otra vez, cada año'].map((point, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4 bg-dark-card p-4 rounded-xl border border-red-900/30" data-id="element-186">
                <span className="text-red-500 mt-1" data-id="element-187">🔴</span>
                <span className="text-gray-300" data-id="element-188">{point}</span>
              </motion.li>)}
          </ul>

          <div className="text-center mt-12 pt-8 border-t border-dark-border" data-id="element-189">
            <p className="text-2xl font-serif font-bold text-gold-gradient" data-id="element-190">
              Basta de regalar tu tiempo libre. Tu dedicación ya la tienes.
              Ahora te falta la herramienta.
            </p>
            <p className="text-xl mt-4 text-white" data-id="element-191">
              Planifica todo tu año de Bromatología hoy.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}